var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTextResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0156 1.60938H2.48438V15.7031C2.48438 24.6719 8.89062 27.2344 14.0156 25.9531C10.1719 22.1094 10.1719 19.5469 10.1719 15.7031H14.0156V1.60938ZM31.9531 1.60938H20.4219V15.7031C20.4219 24.6719 26.8281 27.2344 31.9531 25.9531C28.1094 22.1094 28.1094 19.5469 28.1094 15.7031H31.9531V1.60938Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextResponse);
export default __webpack_public_path__ + "static/media/icon-text-response.ca54e3e86b9a81ee28f0a1193d5641d9.svg";
export { ForwardRef as ReactComponent };